<template>
  <div class="panel-admin-body">
    <div class="d-flex title">
      <div class="pb-1"><modal-link modal-id="How to Use"></modal-link>{{ title }}</div>
      <div class="ml-auto">
        <i v-show="this.$parent.displayShowMenuIcon && this.$root.getShowHeaderMenu()" class="fa fa-window-minimize pl-1 pr-1" aria-hidden="true" @click="$parent.toggleHeaderMenu()"></i>
        <i v-show="this.$parent.displayShowMenuIcon && !this.$root.getShowHeaderMenu()" class="fa fa-window-maximize pl-1 pr-1" aria-hidden="true" @click="$parent.toggleHeaderMenu()"></i>
      </div>
    </div>
    <respondent-menu></respondent-menu>
    <div v-if="!permissionToView" class="no-permission text-center">You do not have permission to view this page</div>   
    <div v-else v-show="getDisplayView()" id="response-rates-title-and-chart" class="response-rates ml-5 title-and-chart d-flex pt-3">
      <div id="response-rates-data-container">
        <table v-show="getDisplayView()" :id="responseRatesTable.id" :class="responseRatesTable.class">
          <thead>
            <tr>
              <th
                v-for="(tableHeader, idxTableHeader) in this.responseRatesData.tableHeader"
                v-bind:key="idxTableHeader"
                v-bind:class="[tableHeader.hasOwnProperty('headerClass') ? tableHeader.headerClass : 'base-column']"
              >
                <span>
                  {{ tableHeader.data }}
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, idxRows) in this.responseRatesData.rowsMap.rows" v-bind:key="idxRows">
              <td v-for="(needRow, idxNeedsRow) in row" v-html="needRow.data" v-bind:key="idxNeedsRow" v-bind:class="[needRow.hasOwnProperty('dataClass') ? needRow.dataClass : 'base-column']">
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <modal :modal-id="'snap-message'" :modal-title="'Snap in progress....'" :modal-content="snapModalContent" />
      <div v-for="(pageContent, idxPageContent) in pageContent" v-bind:key="idxPageContent">
        <modal :modal-id="pageContent.title" :modal-title="pageContent.title" :modal-content="pageContent.contentText" />
      </div>
    </div>
    <counts-by-location ref="countsByLocation" :period="currentPeriod"/>
  </div>
</template>
<script>
import $ from "jquery";

import PrintAndCopyService from "../../services/print.and.copy.service";
import TableService from "../../services/table.service";

import GoogleService from "../../services/google.service";
import AdminService from "../../services/admin.service";
import SurveyService from "../../services/survey.service";
import ContentMixins from "../../mixins/ContentMixins.vue";
import RespondentMixins from "../../mixins/RespondentMixins.vue";
import RespondentMenu from "../../views/menu/RespondentMenu.vue";
import DataTableMixins from "../../mixins/DataTableMixins.vue";
import CountsByLocation from "../../modals/CountsByLocation.vue";

export default {
  name: "ResponseRates",
  mixins: [ContentMixins, RespondentMixins, DataTableMixins],
  components: {
    RespondentMenu,CountsByLocation
  },
  props: {},
  data() {
    return {
      pageNumber: 2,
      title: "Rates",
      chart: {
        title: "Rates"
      },
      responseRatesData: {
        rowsMap: {}
      },
      positiveClass: "text-success",
      negativeClass: "text-danger",
      baseClass: "base-column",
      notActiveClass: "",
      currentPeriod: "0",
      responseRatesTable: {
        id: "response-rate-table",
        class: "table display wrap row-border table-hover",
        columns: [],
        configuration: {
          dom: '<"title-and-table-left"<"table-header"><B>>frtip',
          searching: false,
          paging: false,
          select: true,
          processing: false,
          responsive: true,
          destroy: true,
          info: false,
          ordering: true,
          keys: true,
          sort: false,
          bSortable: false,
          bSort: false,
          buttons: [],
          columnDefs: [
            { orderSequence: ["desc", "asc"], targets: ["_all"] },
            { targets: [0], visible: true },
            {
              targets: "_all",
              width: "50px"
            }
          ]
        }
      },
      snapModalContent: PrintAndCopyService.getSnapMessage()
    };
  },
  methods: {
    async snapChart(displayLegend, snapContainerId) {
      PrintAndCopyService.initializeSnapChart(displayLegend, snapContainerId, this); 
    },
    showCountsByLocation(period){
      this.currentPeriod = period;
      this.$refs.countsByLocation.loadData();
      this.$modal.show("counts-by-location");

    },
    clearTable() {
      this.responseRatesData = {};
      this.responseRatesData.rowsMap = {};
    },
    async getTableData() {
      if (typeof this.responseRatesTable.dataTable != "undefined") {
        this.responseRatesTable.dataTable.destroy();
      }
      this.setDisplayView(false);
      this.$root.processServerRequest("Retrieving data");
      SurveyService.getResponseRates(this.getTableDataCallback, this);
    },
    isNumber(value) {
      return value != "--";
    },
    getTableDataCallback(response) {
      this.$root.processServerResponse();
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.responseRatesData = response.data.data.responseRatesData;
        this.responseRatesTable.configuration.order = [];
        setTimeout(() => {
          const vm = this;
          $(document).ready(function() {
            $.extend(vm.responseRatesTable.configuration, TableService.getTableButtons(vm, "response-rates-data-container"));
            vm.responseRatesTable.dataTable = $("#" + vm.responseRatesTable.id).DataTable(vm.responseRatesTable.configuration);
          });
          vm.setDisplayView(true);
        }, 500);
      } else if (statusCode == 201) {
        this.$notify(AdminService.displaySuccessMessage({ text: response.data.message },true));
      } else {
        this.$notify(AdminService.displayErrorMessage({ text: response.data.message }));
      }
    },
    loadData: function() {
      if (!this.isW5OUser){
        this.getTableData();
      }
    }
  },
  mounted() {},
  watch: {},
  computed: {}
};
</script>
